export function ModulFFocusStyles({ colors }) {
    return {
        focusedBoundaryDark: `1px dotted ${colors.interaction.focus.color}`,
        focusedBoundaryLight: `1px dotted ${colors.interaction.focus.color}`
    };
}
